import React, { cloneElement, isValidElement, ReactNode } from "react"
import { Tooltip, Box } from "@material-ui/core"

import { usePermissionStateStore } from "@/store/PermissionState"

import { PermissionFeature, PermissionFeatureToActions } from "@/protocols/permission"

import useStyles from "@/components/PermissionGate/BasePermissionGate/styles"

export const PERMISSION_DENIED_MESSAGE =
	"Você não tem permissão para acessar este recurso. Fale com o gestor da instância."

export type BasePermissionGateProps<Feature extends PermissionFeature> = {
	feature: Feature
	action: PermissionFeatureToActions[Feature]
	children: ReactNode
	tooltip?: string
	partialBlockRule?: () => boolean
}

const BasePermissionGate = <Feature extends PermissionFeature>({
	feature,
	action,
	children,
	tooltip = PERMISSION_DENIED_MESSAGE,
	partialBlockRule
}: BasePermissionGateProps<Feature>) => {
	const { checkPermission } = usePermissionStateStore()

	const classes = useStyles()

	const hasPermission = checkPermission(feature, action)

	const resolveAccess = (): boolean => {
		if (hasPermission) return true

		if (partialBlockRule) {
			return partialBlockRule()
		} else {
			return false
		}
	}

	const isAllowed = resolveAccess()

	if (!isAllowed) {
		return (
			<Tooltip
				title={tooltip}
				arrow
			>
				<Box
					component="span"
					className={classes.disabledBox}
					onClick={(event) => event.stopPropagation()}
				>
					{isValidElement(children)
						? cloneElement(children as React.ReactElement, { disabled: true })
						: children}
				</Box>
			</Tooltip>
		)
	}

	return <>{children}</>
}

export default BasePermissionGate
